// extracted by mini-css-extract-plugin
export default {"wrapper":"Error404_wrapper__5fIN1","errorImg":"Error404_errorImg__6ro3U","errorText":"Error404_errorText__fYa9A","button":"Error404_button__kqsXW"};